import { BasketStatus } from 'graphql-api/baskets-api-interfaces';

/**
 * Converts dto string to gql enum.
 */
export function mapDtoStatus(status: string) {
  return statusMap[status];
}

/**
 * Converts gql enum to dto string.
 */
export function mapGqlStatusToDto(status: BasketStatus) {
  return gqlStatusMap[status];
}

const statusMap: { [status: string]: BasketStatus } = {
  ['New']: BasketStatus.New,
  ['Submitted']: BasketStatus.Submitted,
  ['Processed']: BasketStatus.Processed,
  ['Processing']: BasketStatus.Processing,
  ['Failed']: BasketStatus.Failed,
  ['Acknowledged']: BasketStatus.Acknowledged,
  ['PaymentInitiated']: BasketStatus.PaymentInitiated,
  ['PaymentFailed']: BasketStatus.PaymentFailed,
  ['PaymentSuccess']: BasketStatus.PaymentSuccess,
  ['Pending']: BasketStatus.Pending,
  ['Rejected']: BasketStatus.Rejected,
  ['Accepted']: BasketStatus.Accepted,
};

const gqlStatusMap: { [key in BasketStatus]: string } = {
  [BasketStatus.New]: 'New',
  [BasketStatus.Submitted]: 'Submitted',
  [BasketStatus.Processed]: 'Processed',
  [BasketStatus.Processing]: 'Processing',
  [BasketStatus.Failed]: 'Failed',
  [BasketStatus.Acknowledged]: 'Acknowledged',
  [BasketStatus.PaymentInitiated]: 'PaymentInitiated',
  [BasketStatus.PaymentFailed]: 'PaymentFailed',
  [BasketStatus.PaymentSuccess]: 'PaymentSuccess',
  [BasketStatus.Pending]: 'Pending',
  [BasketStatus.Rejected]: 'Rejected',
  [BasketStatus.Accepted]: 'Accepted',
};
